import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Button,
  Paper,
  Grid,
} from "@mui/material";
import { investorApi } from "../../api/api";
import { useSelector } from "react-redux";
import moment from "moment";
import { data, useNavigate } from "react-router-dom";
import SecondaryButton from "../common/SecondaryButton";
import Loader from "../common/Loader";
import GradientButton from "../common/GradiantButton";

const SubscriptionDetails = () => {
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);
  const userId = useSelector((state) => state.user.userId);
  const isSubscribed = useSelector((state) => state.user.isSubscribed);
  const theme = useSelector((data) => data.themeValue.colors)
  const navigate = useNavigate();
  const [message, setMessage] = useState("")
  const updateSubscriptionStatus = async () => {
    try {
      await investorApi.updateSubscriptionStatus(userId);
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };
  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchSubscription = async () => {
      try {
     
        const response = await investorApi.getSubscriptionsById(userId);
      
        if (response.status === 200) {
          // const subscriptionData = response.data.subscription;
          // setSubscription(subscriptionData);

          const data = response.data;

// If paid subscription exists → use it
// Else → build a Free plan object from root response
const subscriptionData = data.subscription ?? {
  plan_name: data.plan_name,        // "Free"
  property_limit: data.property_limit,
  project_limit: data.project_limit,
  property_count: data.property_count,
  project_count: data.project_count,
  status: "Active",
  start_date: "-",
  end_date: "-",
  price: 0,
  period: "Free",
};

setSubscription(subscriptionData);
          const endDate = moment(subscriptionData.end_date);
          const currentDate = moment();
          if (endDate.isBefore(currentDate) && subscriptionData.status === "Active") {
            await updateSubscriptionStatus();
          }
          if (!response.data.within_project_limit || !response.data.within_property_limit) {
            // setMessage("Upgrade your plan to add more properties.");
          }
        } else {
          alert(`Failed to fetch subscriptions: ${response.status}`);
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSubscription();
  }, [userId]);
const handleRenew = () => {
  navigate("/SubscriptionPlans", {
    state: {
      selectedPlan: subscription.plan_name,  
      selectedPeriod: subscription.period,   
    },
  });
};

const handleUpgrade = () => {
  navigate("/SubscriptionPlans", {
    state: {
      selectedPlan: subscription.plan_name,
      selectedPeriod: subscription.period,
    },
  });
};

  if (loading) {
    return (
      <Loader />
    );
  }
 if (loading || !subscription) {
  return <Loader />;
}

const currentDate = moment();
const endDate = moment(subscription?.end_date);
const isExpired = endDate.isBefore(currentDate);

  return (
    <Container sx={{ minHeight: "100vh" ,marginTop:7}}>
      <Typography variant="h4" fontWeight="bold" align="center" sx={{ margin: "10px", color: theme.text }}>
        Subscription Details
      </Typography>
      {message && (
        <Typography sx={{ color: theme.text }}>{message}</Typography>
      )}
      <Paper elevation={3} sx={{ p: 3, borderRadius: 3, backgroundColor: theme.background, width: "100%" }}>
        <Grid container spacing={2} sx={{ display: "flex", flexDirection: "column" }}>
          {/* First container */}
          <Grid item xs={12} sm={6} md={4}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center", // ✅ keep both vertically aligned
                gap: 2,
                p: 2,
                backgroundColor: theme.background,
                flexWrap: "wrap" // ✅ ensures no overflow on smaller screens
              }}
            >
              {/* Left section: Plan name + status */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "5px",
                  flexWrap: "nowrap"
                }}
              >
                <Typography sx={{ fontSize: "18px", color: theme.text }}>
                  {subscription.plan_name} Plan
                </Typography>
                <Typography
                  sx={{
                    padding: "3px 10px",
                    backgroundColor:
                      subscription.status === "Active" ? "#D4EDDA" : "#FFCCCC",
                    border: "1px solid",
                    borderColor: subscription.status === "Active" ? "green" : "red",
                    borderRadius: 3
                  }}
                >
                  {subscription.status}
                </Typography>
              </Box>

              {/* Right section: Button */}
              {(isExpired || subscription.plan_name !== "Platinum") && (
              <Box>
                <GradientButton
                  text={isExpired ? "Renew Plan" : "Upgrade Plan"}
                  onClick={isExpired ? handleRenew : handleUpgrade}
                  width="100%"
                />
              </Box>
              ) }

            </Box>
            {subscription.status === "Pending" && (
              <Typography
                sx={{
                  color: "orange",
                  fontWeight: "bold",
                  textAlign: "center",
                  mt: 2
                }}
              >
                Please contact the admin to approve your subscription.
              </Typography>
            )}
            {subscription.status === "Rejected" && (
              <Typography
                sx={{
                  color: "orange",
                  fontWeight: "bold",
                  textAlign: "center",
                  mt: 2,
                  px: 2, // optional: add some horizontal padding
                }}
                variant="body1"
              >
                Your subscription payment has been rejected by admin. Please contact admin for more details.
              </Typography>
            )}


          </Grid>
          {/* Second container */}
          <Grid item xs={12} md={6} sm={4}>
            <Box
              sx={{
                backgroundColor: theme.background,
                p: 3,
                border: "1px solid lightgray",
                borderRadius: 2,
              }}
            >
              <Grid container spacing={{ xs: 4, sm: 10 }} sx={{ backgroundColor: theme.background }}>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography fontWeight="bold" sx={{ color: theme.text }}>Start Date</Typography>
                  <Typography sx={{ color: theme.text }}>{subscription.start_date}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography fontWeight="bold" sx={{ color: theme.text }}>Valid Until</Typography>
                  <Typography sx={{ color: theme.text }}>{subscription.end_date}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography fontWeight="bold" sx={{ color: theme.text }}>Next Billed Amount</Typography>
                  <Typography sx={{ color: theme.text }}>
                    ₹{subscription.price} / {subscription.period}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography fontWeight="bold" sx={{ color: theme.text }}>Renew On</Typography>
                  <Typography sx={{ color: theme.text }}>{subscription.end_date}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography fontWeight="bold" sx={{ color: theme.text }}>Property Limit</Typography>
                  <Typography sx={{ color: theme.text }}>{subscription.property_limit}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography fontWeight="bold" sx={{ color: theme.text }}>Project Limit</Typography>
                  <Typography sx={{ color: theme.text }}>{subscription.project_limit}</Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};
const Detail = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="body1" fontWeight="bold" color="text.secondary">
      {label}:
    </Typography>
    <Typography variant="body1" color="text.primary">
      {value}
    </Typography>
  </Grid>
);
export default SubscriptionDetails;